import { createContext, useContext, useReducer, useEffect } from "react";

type AppData = {
  consulting: boolean;
  reset: boolean;
  milling: boolean;
  shelf: boolean;
};

type AppState = AppData;

type AppAction = {
  type: "CONSULTING" | "RESET" | "MILLING" | "SHELF" | "SET" | "NOSET";
};

const initialState: AppState = {
  consulting: false,
  reset: false,
  milling: false,
  shelf: false,
};

const AppContext = createContext<{
  state: AppState;
  dispatch: React.Dispatch<any>;
}>({
  state: initialState,
  dispatch: () => null,
});

const reducer = (state: AppState, action: AppAction) => {
  switch (action.type) {
    case "CONSULTING": {
      return { ...state, consulting: !state.consulting };
    }
    case "SET": {
      return { ...state, reset: true };
    }

    case "NOSET": {
      return { ...state, reset: false };
    }

    case "RESET": {
      return { ...state, milling: false, shelf: false };
    }
    case "MILLING": {
      return { ...state, milling: !state.milling };
    }

    case "SHELF": {
      return { ...state, shelf: !state.shelf };
    }
  }
};

const DataProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(
    reducer,
    {
      consulting: false,
      reset: false,
      milling: false,
      shelf: false,
    },
    (): any => {
      const localData = localStorage.getItem("app_state");
      return localData ? JSON.parse(localData) : initialState;
    }
  );

  useEffect(() => {
    localStorage.setItem("app_state", JSON.stringify(state));
  }, [state]);

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  );
};

export default DataProvider;
export const useAppState = () => useContext(AppContext);

// RESET
// SWITCH

// method: milling, shelf
// material: aluminum, carbon steel, copper, alloy steel, steel
